export default {"src":"/_next/static/media/logo-text.8efe8316.svg","height":58,"width":188,"blurWidth":0,"blurHeight":0};